<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <div
      class="cf-content"
      v-html="loyaltyProgramDetailsContent"
    />

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="closeModalClickHandler"
    >
      Okay
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'LoyaltyProgramDetails',

    computed: {
      ...mapGetters('content', ['content']),

      loyaltyProgramDetailsContent() {
        return this.content.PayAtTableLoyaltyProgramDetails.metadata.programDetails;
      }
    },

    methods: {
      closeModalClickHandler() {
        this.$closeModal('loyaltyProgramDetailsModal');
      }
    }
  };
</script>

